import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getMaster = data => post(URL.GET_MASTER, data);
export const getGeneralMaster = data => post(URL.GET_GENERAL_MASTER, data);



